export default __webpack_public_path__ + "static/media/uploadImgBtn.7ee92633.svg";